import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Componente que valida el acceso a rutas basado en el rol del usuario
 * 
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Componentes hijos a renderizar si el usuario tiene permiso
 * @param {Array} props.allowedRoles - Lista de roles permitidos para acceder a esta ruta
 * @param {Object} props.profile - Perfil del usuario con su rol
 * @param {string} props.redirectTo - Ruta a la que redirigir si no se tiene permiso (opcional, por defecto '/')
 */
const RoleBasedRoute = ({ 
  children, 
  allowedRoles, 
  profile, 
  redirectTo = '/' 
}) => {
  // Obtener el rol del usuario
  const userRole = profile?.role || 'Agente';
  
  // Verificar si el usuario tiene permiso para acceder a esta ruta
  const hasPermission = allowedRoles.includes(userRole);
  
  if (!hasPermission) {
    // Si no tiene permiso, redirigir a la ruta especificada
    return <Navigate to={redirectTo} replace />;
  }
  
  // Si tiene permiso, renderizar los componentes hijos
  return children;
};

export default RoleBasedRoute; 